<section class="filters pt-3 lg:pt-4">
  <ng-content></ng-content>

  <ul *ngIf="filters?.length" class="flex">
    <li
      *ngFor="let filter of filters; let isFirst = first"
      [class.ml-3]="!isFirst"
    >
      <ng-container [ngTemplateOutlet]="filter.itemTemplate"></ng-container>
    </li>
  </ul>

  <app-divider class="block -mt-2 lg:mt-3"></app-divider>
</section>
